import { z } from 'zod'

import type {
  TypeDailyTipSkeleton,
  TypeSubjectSkeleton,
  TypeWeekSkeleton,
} from '../types/generated/contentful'
import type {
  DashboardContentSubject,
  DashboardContentTip,
  DashboardContentWeek,
} from './contentful-types'
import { contentfulClient } from './contentful-client'
import {
  mapDashboardContentSubject,
  mapDashboardContentTip,
  mapDashboardContentWeek,
} from './contentful-mappers'
import {
  dashboardContentSubjectSchema,
  dashboardContentTipSchema,
  dashboardContentWeekSchema,
} from './contentful-types'

const MORNING_ROUTINE_SUBJECT_ID = '2BkF7Fddm3NIvoBYneryUV'

export async function fetchDashboardSubjects(
  locale: string,
): Promise<DashboardContentSubject[]> {
  const response = await contentfulClient.getEntries<TypeSubjectSkeleton>({
    content_type: 'subject',
    include: 10,
    locale,
  })

  return z
    .array(dashboardContentSubjectSchema)
    .parse(response.items.map(mapDashboardContentSubject))
}

export async function fetchDashboardWeeks(
  locale: string,
): Promise<DashboardContentWeek[]> {
  const response = await contentfulClient.getEntries<TypeWeekSkeleton>({
    content_type: 'week',
    include: 10,
    locale,
  })

  return z
    .array(dashboardContentWeekSchema)
    .parse(response.items.map(mapDashboardContentWeek))
}

export async function fetchDashboardTips(
  locale: string,
): Promise<DashboardContentTip[]> {
  const response = await contentfulClient.getEntries<TypeDailyTipSkeleton>({
    content_type: 'dailyTip',
    include: 10,
    locale,
  })

  return z
    .array(dashboardContentTipSchema)
    .parse(response.items.map(mapDashboardContentTip))
}

export async function fetchMorningRoutineSubject(
  locale: string,
): Promise<DashboardContentSubject | null> {
  const subject = await contentfulClient.getEntry<TypeSubjectSkeleton>(
    MORNING_ROUTINE_SUBJECT_ID,
    {
      include: 10,
      locale,
    },
  )

  return subject == null
    ? null
    : dashboardContentSubjectSchema.parse(mapDashboardContentSubject(subject))
}

export type {
  DashboardContentSubject,
  DashboardContentTip,
  DashboardContentWeek,
} from './contentful-types'
